import register from 'ShopUi/app/registry';
import { importWithFallback } from 'PyzShopUi/scripts/utils/importWithFallback';

export default register('summary-form', () =>
    importWithFallback(
        /* webpackMode: "lazy" */
        () => import('./summary-form')
    ),
);
